export default __webpack_public_path__ + "static/media/5.1e95435a.png";